import {
    HttpResponse,
    ShiftTeamTypeModel,
    QueryModel,
    RequestParams,
    ShiftTeamTypeModelIEnumerableApiResultSuccess,
    ShiftTeamTypeModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel,
} from '@/libs/Api';
import ApiService from '@/libs/core/api-service';
import { CrudDataQuery, CrudService } from '@/libs/core/+state/models/crud-service';
import { CrudEnumerableResponse, CrudResponse } from '../core/+state/models/crud-response';
import { CrudPartialUpdatePatch } from '@/libs/core/+state/models/crud-partial-update-patch';

export class ShiftTeamTypesDataService implements CrudService<ShiftTeamTypeModel, ShiftTeamTypeModel> {
    getAll(query: CrudDataQuery<ShiftTeamTypeModel>): Promise<CrudEnumerableResponse<ShiftTeamTypeModel>> {
        return ApiService.api.getShiftTeamTypeBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<ShiftTeamTypeModel>): Promise<CrudEnumerableResponse<ShiftTeamTypeModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ShiftTeamTypeModel>> {
        return ApiService.api.getShiftTeamTypeById(id, params);
    }

    create(item: ShiftTeamTypeModel, params?: RequestParams): Promise<CrudResponse<ShiftTeamTypeModel>> {
        return ApiService.api.insertShiftTeamType(item, params);
    }

    update(item: ShiftTeamTypeModel, params?: RequestParams): Promise<ShiftTeamTypeModel> {
        return ApiService.api
            .updateShiftTeamType(item.id as Required<string>, item, params)
            .then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ShiftTeamTypeModel> {
        return ApiService.api.patchShiftTeamType(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<ShiftTeamTypeModel>): Promise<CrudEnumerableResponse<ShiftTeamTypeModel>> {
        return ApiService.api.deleteShiftTeamTypes(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationShiftTeamType(query, params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<ShiftTeamTypeModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: ShiftTeamTypeModel, params?: RequestParams): Promise<CrudResponse<ShiftTeamTypeModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getShiftTeamTypeGroupped(query, params);
    }
}


